var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1440,
    height: 935,
    viewBox: "0 0 1440 935",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "9k3u7o7vra",
    d: "M0 0h139v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dql79eq4zc",
    d: "M0 0h273v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qewco3aqie",
    d: "M0 0h325v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "da8w3qe8vg",
    d: "M0 0h523v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "6dk3vbdl4i",
    d: "M0 0h622v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rcrvjjpi1k",
    d: "M0 0h712v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "ftberrtwum",
    d: "M0 0h734v468H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "5tzi1g4qao",
    d: "M0 0h712v364H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "0xg5nsbjqq",
    d: "M0 0h734v254H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "qeqm0n75ls",
    d: "M0 0h712v52H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "96zkysykuu",
    d: "M0 0h734v51H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "v9fkmpydvw",
    d: "M0 0h712v255H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "oloje78yby",
    d: "M0 0h734v364H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "s4c2hfn2iA",
    d: "M0 0h712v467H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "rk1wpr8uiC",
    d: "M0 0h714v467H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "f5t0epe55E",
    d: "M0 0h621v467H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "r9y9xzb0xG",
    d: "M0 0h523v467H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "9ajglby4jI",
    d: "M0 0h324v467H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "byezneoi5K",
    d: "M0 0h274v467H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "hxyz1xvucM",
    d: "M0 0h140v467H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.006
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(593 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "o0hhid6xkb",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9k3u7o7vra"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M134.697 806.326c-45.028 0-90.348-3.159-134.697-9.389L134.713 0c.968.137-1.142 0 0 0L139 806.317l-4.303.01z",
    fill: "#FEFEFE",
    mask: "url(#o0hhid6xkb)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ak42blhbad",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dql79eq4zc"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M218.649 781.269.078.016c.27-.062-.27.08 0 0L273 766.866a947.392 947.392 0 0 1-54.351 14.403",
    fill: "#FEFEFE",
    mask: "url(#ak42blhbad)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(403 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sk4k36uawf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qewco3aqie"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M53.09 767.111A939.177 939.177 0 0 1 0 749.624L324.905.024c.325.118-.316-.092 0 0L53.09 767.111z",
    fill: "#FEFEFE",
    mask: "url(#sk4k36uawf)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "way5lpzsjh",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#da8w3qe8vg"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M403.454 717.18.213.093c.782-.37-.75.508 0 0L523 649.44c-37.718 25.388-77.942 48.179-119.546 67.74",
    fill: "#FEFEFE",
    mask: "url(#way5lpzsjh)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(107 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "pkeg2oi12j",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#6dk3vbdl4i"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M107.149 654.853C69.214 629.928 33.165 602.023 0 571.911L621.798.142c.727.658-.808-.534 0 0l-514.65 654.711z",
    fill: "#FEFEFE",
    mask: "url(#pkeg2oi12j)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "dafbczgiml",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rcrvjjpi1k"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M678.704 514.568.073.08c.26-.287-.254.315 0 0L713.162 474.02a829.025 829.025 0 0 1-34.458 40.55",
    fill: "#FEFEFE",
    mask: "url(#dafbczgiml)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "5bos06d74n",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#ftberrtwum"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M21.455 474.57a811.427 811.427 0 0 1-31.7-42.587L733.955.078c.171.252-.213-.265 0 0L21.454 474.57z",
    fill: "#FEFEFE",
    mask: "url(#5bos06d74n)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "z2z9iwn39p",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#5tzi1g4qao"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M786.641 364 .053.182c.35-.634-.223.642 0 0L840.15 244.61c-14.252 40.901-32.257 81.07-53.508 119.391",
    fill: "#FEFEFE",
    mask: "url(#z2z9iwn39p)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 467)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s0xmmqzmfr",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#0xg5nsbjqq"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M-102.738 254c-14.769-40.79-26.039-83.01-33.5-125.483L733.973.173c.122.698-.226-.625 0 0L-102.738 254z",
    fill: "#FEFEFE",
    mask: "url(#s0xmmqzmfr)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728 466)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "7z3m46ftut",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#qeqm0n75ls"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M879.938 52 0 1.183c.033-.49 0 .48 0 0L881.686 0v.831c0 16.987-.588 34.204-1.748 51.169",
    fill: "#FEFEFE",
    mask: "url(#7z3m46ftut)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 417)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cr9fqsflov",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#96zkysykuu"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m734 50.875-881.452.068v-.42c0-16.79.57-33.788 1.699-50.523L734 50.875c-.027.441 0-.465 0 0",
    fill: "#FEFEFE",
    mask: "url(#cr9fqsflov)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728 212)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "nhvqodv7tx",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#v9fkmpydvw"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.028 254.828c-.125-.692.223.62 0 0L836.673 0c14.82 40.7 26.144 82.835 33.653 125.228L.028 254.828z",
    fill: "#FEFEFE",
    mask: "url(#nhvqodv7tx)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-6 103)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sa7fahw26z",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#oloje78yby"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m733.949 363.821-840.152-244.352C-91.997 78.548-74.038 38.353-52.83 0l786.778 363.821c-.345.62.216-.62 0 0",
    fill: "#FEFEFE",
    mask: "url(#sa7fahw26z)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "01r8z9gx7B",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#s4c2hfn2iA"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.05 466.922c-.185-.262.214.268 0 0L712.207-8.342A809.44 809.44 0 0 1 743.94 34.13L.05 466.922z",
    fill: "#FEFEFE",
    mask: "url(#01r8z9gx7B)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(14)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "ckulnxj8cD",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rk1wpr8uiC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M713.948 466.927 0-6.397a821.736 821.736 0 0 1 34.57-40.7l679.378 514.024c-.227.25.192-.243 0 0",
    fill: "#FEFEFE",
    mask: "url(#ckulnxj8cD)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "s0bka7ittF",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#f5t0epe55E"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.205 466.86c-.737-.67.814.533 0 0l513.634-655.091C551.77-163.383 587.82-135.554 621-105.516L.205 466.859z",
    fill: "#FEFEFE",
    mask: "url(#s0bka7ittF)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "fm5m8o7iaH",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#r9y9xzb0xG"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M522.787 466.91 0-181.865c37.648-25.401 77.797-48.208 119.328-67.785l403.459 716.558c-.77.361.746-.504 0 0",
    fill: "#FEFEFE",
    mask: "url(#fm5m8o7iaH)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(728)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "f1fbvgbanJ",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#9ajglby4jI"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M.075 466.976c-.27-.099.294.087 0 0l270.722-767.12A936.756 936.756 0 0 1 324-282.68L.075 466.976z",
    fill: "#FEFEFE",
    mask: "url(#f1fbvgbanJ)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(454)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "765r640v6L",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#byezneoi5K"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.929 466.989 0-299.375a949.025 949.025 0 0 1 54.495-14.474L273.93 466.989c-.2.045.234-.068 0 0",
    fill: "#FEFEFE",
    mask: "url(#765r640v6L)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(722)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "9vt6i9a3qN",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#hxyz1xvucM"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M5.967 467c-.94-.133 1.118 0 0 0L0-339.03c46.631-.33 93.912 2.825 140 9.239L5.967 467z",
    fill: "#FEFEFE",
    mask: "url(#9vt6i9a3qN)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/bg.c025d40f44d6539eb7e2eb9ef915444a.svg";
export { ForwardRef as ReactComponent };